import { FAQSection } from "../FAQSection";
import { getHomeFAQ } from "./HomeFAQ";
import { SectionHeader } from "@/src/components/SectionHeader";
import Translations from "@translate/components/Home/HomeFAQSection";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export const HomeFAQSection = ({ type }: { type?: "crypto" | "stock" }) => {
  const items = getHomeFAQ(type || "stock");

  return (
    <div className="flex flex-col gap-4">
      <SectionHeader
        title={I18n.t("FAQ")}
        showChevron={false}
        className="md:block hidden"
      />
      <FAQSection items={items} />
    </div>
  );
};
